let uid = 0;

export default () => {
  return 'uid-' + uid++;
}
